module.exports = __webpack_public_path__ + "img/talron-phone.6b1a5f17.svg";